import React from 'react';

import Loader from "../common/Loader";
import * as clientActions from "../../actions/client";
import * as currencyActions from "../../actions/currency";
import {connect} from "react-redux";
import ClientTable from "./ClientTable";
import {Button} from "react-materialize";
import * as creationActions from "../../actions/creation";
import ClientTabs from "./ClientTabs";

class ClientTableWrapper extends React.Component {

    componentDidMount() {
        this.props.dispatch(clientActions.fetchClients(true));
        this.props.dispatch(currencyActions.fetchCurrencies());
    }

    render() {
        if (this.props.loadingClients || this.props.loadingCurrencies || this.props.clients === undefined || this.props.currencies === undefined) {
            return (<div><Loader /></div>)
        }

        return (
            <div>
                <Button floating onClick={() => this.props.handleClick(ClientTabs, {item: null}, creationActions.destroyingnewlyCreatedClient())} icon="add" className="add-button" />
                {<ClientTable  {...this.props} data={this.props.clients} />}
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        currencies: state.currency.currencies,
        clients: state.client.clients,
        loadingClients: state.client.loading,
        loadingCurrencies: state.currency.loading,
        deletetingClient: state.client.deleting
    });
})(ClientTableWrapper);


// WEBPACK FOOTER //
// ./src/components/client/ClientTableWrapper.js